const angular = require('angular')
angular.module('ui.hxphone.helpers', [])

/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO(后进先出：栈结构) order
 */
  .factory('$$stackedMap', function () {
    return {
      createNew: function () {
        const stack = []

        return {
          add: function (key, value) {
            stack.push({
              key: key,
              value: value
            })
          },
          get: function (key) {
            for (let i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                return stack[i]
              }
            }
          },
          keys: function() {
            const keys = []
            for (let i = 0; i < stack.length; i++) {
              keys.push(stack[i].key)
            }
            return keys
          },
          top: function () {
            return stack[stack.length - 1]
          },
          remove: function (key) {
            let idx = -1
            for (let i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                idx = i
                break
              }
            }
            return stack.splice(idx, 1)[0]
          },
          removeTop: function () {
            return stack.splice(stack.length - 1, 1)[0]
          },
          length: function () {
            return stack.length
          }
        }
      }
    }
  })

  .factory('$$uiHelpers', ['$transition', '$timeout', '$document', function ($transition, $timeout, $document) {
    return {
      removeAfterAnimate: function (domEl, scope, emulateTime, done) {
        const domElRef = domEl
        const scopeRef = scope
        // Closing animation
        scopeRef.animate = false

        const transitionEndEventName = $transition.transitionEndEventName
        if (transitionEndEventName) {
          // transition out
          const timeout = $timeout(afterAnimating, emulateTime)
          domElRef.bind(transitionEndEventName, function () {
            $timeout.cancel(timeout)
            afterAnimating()
            // fix: [$rootScope:inprog] $digest already in progress
            // https://github.com/angular/angular.js/wiki/Anti-Patterns
            $timeout(function() {
              scopeRef.$apply()
            }, 0)
          })
        } else {
          // Ensure this call is async
          $timeout(afterAnimating, 0)
        }

        function afterAnimating() {
          if (afterAnimating.done) {
            return
          }
          afterAnimating.done = true

          domElRef.remove()
          if (done) {
            done()
          }
        }
      }
    }
  }])

/**
 * A helper directive for the $actionsheet、$modal service. It creates a backdrop element.
 */
  .directive('backdrop', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'views/components/backdrop.html',
      link: function (scope, element) {
        scope.animate = false

        // trigger CSS transitions
        $timeout(function () {
          scope.animate = true
        })

        // 每当屏幕大小变化时，重定位控件，以解决IOS下的定位问题
        function repaint() {
          element.css({position: 'relative'})
          $timeout(function() {
            element.css({position: 'absolute'})
            $rootScope.$emit('COMPOSE_SCROLL_REFRESH')
          }, 100)
        }

        $rootScope.$emit('GLOBAL_ADD_WINDOW_RESIZE_FUN', repaint)

        $rootScope.$on('GLOBAL_REPAINT_BACKDROP', function() {
          repaint()
        })

        scope.$on('$destroy', function() {
          $rootScope.$emit('GLOBAL_REMOVE_WINDOW_RESIZE_FUN', repaint)
          $rootScope.$off('GLOBAL_REPAINT_BACKDROP')
        })
      }
    }
  }])



// WEBPACK FOOTER //
// ./src/js/infrastructure/helpers.js